import { render, staticRenderFns } from "./ReviewState.vue?vue&type=template&id=764b48fe&scoped=true&lang=html&"
import script from "./ReviewState.vue?vue&type=script&lang=js&"
export * from "./ReviewState.vue?vue&type=script&lang=js&"
import style0 from "./ReviewState.vue?vue&type=style&index=0&id=764b48fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b48fe",
  null
  
)

component.options.__file = "ReviewState.vue"
export default component.exports